import React, { useState } from "react"
import TabView from "../../../components/atoms/tabView/TabView.atom"
import TabPanel from "../../../components/atoms/tabView/TabPanel.atom"
import OccupationReport from "./OccupationReport.controller"
import OccupationReportCharts from "./OccupationReportCharts.controller"
import useScreenDimensionsContext from "../../../hooks/contextConsumers/useScreenDimensionsContext.hook"
import { useLocation } from "react-router-dom"

const OccupationReportContent = () => {
  const location = useLocation()
  const tabs = [
    "/reporte-ocupacion/reporte-comparativo",
    "/reporte-ocupacion/graficas",
  ]

  const initialTabIndex = tabs.indexOf(location.pathname)
  const [activeIndex, setActiveIndex] = useState(
    initialTabIndex === -1 ? 0 : initialTabIndex
  )

  const handleTabChange = (e) => {
    setActiveIndex(e.index)
  }

  return (
    <div id="occupation-report">
      <div className="mobile-tab-view-nav-button">
        {activeIndex !== 0 && (
          <button
            className="p-tabview-nav-prev p-tabview-nav-btn p-link"
            type="button"
            onClick={() => handleTabChange({ index: activeIndex - 1 })}
          >
            <span className="pi pi-chevron-left" aria-hidden="true"></span>
          </button>
        )}
        {activeIndex === 0 && <span>Reporte comparativo</span>}
        {activeIndex === 1 && <span>Gráficas</span>}
        <span className="tabview-underline" />
        {activeIndex !== 1 && (
          <button
            className="p-tabview-nav-next p-tabview-nav-btn p-link"
            type="button"
            onClick={() => handleTabChange({ index: activeIndex + 1 })}
          >
            <span className="pi pi-chevron-right" aria-hidden="true"></span>
          </button>
        )}
      </div>
      <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
        <TabPanel header="Reporte comparativo">
          <OccupationReport />
        </TabPanel>
        <TabPanel header="Gráficas">
          <OccupationReportCharts />
        </TabPanel>
      </TabView>
    </div>
  )
}

export default OccupationReportContent
